import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const AlertsComponent = React.lazy(() => import("../Components/RootComponents/AlertsComponent"));
const AlertsPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <AlertsComponent />
      </Suspense>
    </Fragment>
  );
};

export default AlertsPage;
